// extracted by mini-css-extract-plugin
export default {"wrap":"MediaWatermark_wrap__QVGwR","media":"MediaWatermark_media__+wi+d","watermark":"MediaWatermark_watermark__d0ROe"};